import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SEO";
import NewLandingHero from "./newLanding/NewLandingHero";
import NewLandingModeCards from "./newLanding/NewLandingModeCards";
import NewLandingTrustStrip from "./newLanding/NewLandingTrustStrip";
import NewLandingResearchSection from "./newLanding/NewLandingResearchSection";
import NewLandingDebateSection from "./newLanding/NewLandingDebateSection";
import NewLandingFeatures from "./newLanding/NewLandingFeatures";
import NewLandingTestimonials from "./newLanding/NewLandingTestimonials";
import NewLandingFaq from "./newLanding/NewLandingFaq";
import NewLandingConsumerBand from "./newLanding/NewLandingConsumerBand";
import NewLandingCtaBand from "./newLanding/NewLandingCtaBand";
import { LandingPreviewEditorProvider } from "./newLanding/LandingPreviewEditorProvider";
import "./LandingPage.css";
import "./NewLanding.css";

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("scrollTo") === "testimonials" || location.state?.scrollTo === "testimonials") {
      const el = document.getElementById("testimonials");
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="nl-page">
      <SEO
        path="/attorneys"
        title="LawFusion — Multi-AI Legal Intelligence"
        description="The legal AI platform that orchestrates five AI models to research, debate, and synthesize stronger arguments."
      />
      <Header />
      <LandingPreviewEditorProvider>
        <main>
          <NewLandingHero />
          <NewLandingModeCards />
          <NewLandingTrustStrip />
          <NewLandingResearchSection />
          <NewLandingDebateSection />
          <NewLandingTestimonials />
          <NewLandingFeatures />
          <NewLandingFaq />
          <NewLandingConsumerBand />
          <NewLandingCtaBand />
        </main>
      </LandingPreviewEditorProvider>
      <Footer />
    </div>
  );
};

export default LandingPage;
